const colours = {
    trackNotValid: 'rgba(3, 225, 12, 0.3)',
    handleLineColorOverError: '#FBAD1D',
};

export default colours;
